import { isEmpty } from 'lodash';
import { ControlProps } from '@jsonforms/core';
import { Hidden } from '@components/uploadForm/renderers/views/Hidden';
import { AntdCheckbox } from '@components/uploadForm/renderers/views/AntdCheckbox';
import { Form } from 'antd';

export const BooleanControl = ({
  data,
  visible,
  label,
  id,
  enabled,
  uischema,
  schema,
  rootSchema,
  handleChange,
  errors,
  path,
  config,
}: ControlProps) => {
  const isValid = isEmpty(errors);

  return (
    <Hidden hidden={!visible}>
      <Form.Item
        id={id}
        hasFeedback={!isValid}
        help={!isValid ? errors : null}
        className={'m-0 mr-1.5'}
      >
        <AntdCheckbox
          id={`${id}-input`}
          isValid={isEmpty(errors)}
          data={data}
          enabled={enabled}
          visible={visible}
          label={label}
          path={path}
          uischema={uischema}
          schema={schema}
          rootSchema={rootSchema}
          handleChange={handleChange}
          errors={errors}
          config={config}
        />
      </Form.Item>
    </Hidden>
  );
};
